export default __webpack_public_path__ + "static/screeny-130-gpz-unica-m-6-bf3ff59b6ac0f42761d6d19cb010637a.jpg";